import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { queryClient } from '../../../../../../../config/queryClient'
import { NotificationKeys } from '../../../../../../../enums/notificationKeys'
import { QueryKeys } from '../../../../../../../enums/queryKeys'
import { deleteContactPerson } from '../../../../../../../query-api/contactPerson-query'
import { useContactDetail } from '../../../contexts/contactDetailContext'

export const useDeleteContactPerson = () => {
  const { t } = useTranslation()
  const { contact } = useContactDetail()

  const {
    mutate,
    isLoading: isProcessing,
    ...rest
  } = useMutation(deleteContactPerson, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.Contact, contact.id])
    },
    onError: () => {
      notify({
        id: NotificationKeys.ContactPersonDeleted,
        message: t('contact.detail.contact_persons.delete_error'),
        variant: 'error',
      })
    },
  })

  return { deleteContactPerson: mutate, isProcessing, ...rest }
}
